import { http } from 'utils'
import { findIndex } from 'lodash'

// File mutation imports.
import {
  SET_FILES, SET_FILE, ADD_FILE, REMOVE_FILE, CLEAR_FILES, SET_FILES_LOADING
} from 'vx/mutations'

// File state.
const state = {
  files: [],
  loading: false
}

// File state getters.
const getters = {
  //
}

// File actions.
const actions = {

  /**
   * Clear the files in state
   *
   * @param commit
   */
  clearFiles ({ commit }) {
    commit(CLEAR_FILES)
  },

  setFilesLoading ({ commit }, val) {
    commit(SET_FILES_LOADING, val)
  },

  /**
   * Get files for a booking.
   *
   * @return Promise
   */
  getBookingFiles ({commit}, {id, threadId = null}) {
    return http.get(`bookings/${id}/files`, {params: {includeThreadId: threadId}})
      .then((response) => {
        commit(SET_FILES, response.data)

        return response
      })
  },

  addFile ({ state, commit }, { file }) {
    if (state.files.findIndex(f => f.id === file.id) === -1) {
      commit(ADD_FILE, file)
    }
  },

  removeFile ({ state, commit }, { fileId }) {
    commit(REMOVE_FILE, fileId)
  },

  /**
   * Store files related to a booking.
   *
   * @return Promise
   */
  storeBookingFile ({ commit }, { id, file, threadId = null }) {
    commit(SET_FILES_LOADING, true)
    let payload = new FormData()
    payload.append('file', file)
    if (threadId) {
      payload.append('thread_id', threadId)
    }
    return http.post(`bookings/${id}/upload_file`, payload, {
      headers: {'Content-Type': 'multipart/form-data'},
      maxContentLength: 15000000
    }).then((response) => {
      commit(ADD_FILE, response.data)
      commit(SET_FILES_LOADING, false)
      return response
    })
  },

  /**
   * Delete a file.
   *
   * @return Promise
   */
  destroyFile ({ commit }, { id, fileId }) {
    return http.delete(`bookings/${id}/file/${fileId}`)
      .then((response) => {
        commit(REMOVE_FILE, fileId)
        return response
      })
  },

  /**
   * Download a file
   *
   * @return Promise
   */
  downloadFile ({ commit }, { id, file }) {
    window.open(`${file.file_url}`)
  },

  /**
   * Approve a file for a booking.
   *
   * @return Promise
   */
  approveFile ({ commit }, id) {
    return http.get(`file/${id}/approve`)
      .then((response) => {
        commit(SET_FILE, response.data)

        return response
      })
  }
}

// File state mutations.
const mutations = {
  [CLEAR_FILES] (state) {
    state.files = []
  },

  [SET_FILES_LOADING] (state, val) {
    state.loading = val
  },

  /**
   * Set files
   */
  [SET_FILES] (state, files) {
    state.files = files
  },

  /**
   * Remove file
   */
  [SET_FILE] (state, file) {
    let index = findIndex(state.files, listFile => listFile.id === file.id)

    if (index !== -1) {
      state.files.splice(index, 1, file)
    }
  },

  /**
   * Add new file
   */
  [ADD_FILE] (state, file) {
    state.files.push(file)
  },

  /**
   * Remove file
   */
  [REMOVE_FILE] (state, id) {
    let index = findIndex(state.files, file => file.id === id)

    if (index !== -1) {
      state.files.splice(index, 1)
    }
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
